(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.querySelectorAll('[data-article-toc]').forEach((toc) => {
    if (toc.dataset.ready === 'true') return;
    const articleBody = toc.parentElement?.querySelector('[data-article-body]');
    const list = toc.querySelector('[data-article-toc-list]');
    if (!articleBody || !list) return;
    articleBody.querySelectorAll('p').forEach((paragraph) => {
      const strong = paragraph.firstElementChild;
      const hasOtherText = Array.from(paragraph.childNodes).some((node) => node.nodeType === 3 && node.textContent.trim());
      if (paragraph.children.length !== 1 || strong?.tagName !== 'STRONG' || hasOtherText) return;
      const text = strong.textContent?.trim();
      if (!text || text.length > 180) return;
      const heading = document.createElement('h2');
      heading.innerHTML = strong.innerHTML;
      paragraph.replaceWith(heading);
    });
    const headings = Array.from(articleBody.querySelectorAll('h2, h3'));
    if (headings.length < 2) return;
    const usedIds = new Set();
    headings.forEach((heading, index) => {
      const text = heading.textContent?.trim();
      if (!text) return;
      const baseId = text
        .toLocaleLowerCase()
        .normalize('NFKD')
        .replace(/[^\p{L}\p{N}]+/gu, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      let headingId = heading.id || baseId;
      let suffix = 2;
      while (usedIds.has(headingId) || (document.getElementById(headingId) && document.getElementById(headingId) !== heading)) {
        headingId = `${baseId}-${suffix}`;
        suffix += 1;
      }
      usedIds.add(headingId);
      heading.id = headingId;
      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'article-toc__item--h3';
      const link = document.createElement('a');
      link.href = `#${headingId}`;
      link.textContent = text;
      item.appendChild(link);
      list.appendChild(item);
    });
    if (list.children.length >= 2) {
      toc.hidden = false;
      toc.dataset.ready = 'true';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["telepathy-compact-launch-hero"] && !Shopify.designMode) return;
  try {
    
  function initCompactTelepathyHero(hero) {
    if (hero.dataset.ready === 'true') return;
    hero.dataset.ready = 'true';
    var slides = Array.from(hero.querySelectorAll('[data-tch-slide]'));
    var progress = hero.querySelector('[data-tch-progress]');
    var current = 0;
    var timer;
    var delay = Math.max(4, Number(hero.dataset.delay || 5));
    var canRotate = hero.dataset.autoplay === 'true' && slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hero.style.setProperty('--tch-delay', delay + 's');
    function restartProgress() {
      if (!progress || !canRotate) return;
      progress.classList.remove('is-running');
      progress.offsetHeight;
      progress.classList.add('is-running');
    }
    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function(slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      restartProgress();
    }
    function stop() { window.clearInterval(timer); }
    function start() {
      stop();
      if (!canRotate) return;
      timer = window.setInterval(function() { show(current + 1); }, delay * 1000);
      restartProgress();
    }
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function() { if (document.hidden) stop(); else start(); });
    document.addEventListener('shopify:block:select', function(event) {
      var index = slides.findIndex(function(slide) { return slide.dataset.blockId === event.detail.blockId; });
      if (index >= 0) { stop(); show(index); }
    });
    document.addEventListener('shopify:block:deselect', start);
    show(0);
    start();
  }
  document.querySelectorAll('[data-tch]').forEach(initCompactTelepathyHero);
  document.addEventListener('shopify:section:load', function(event) { event.target.querySelectorAll('[data-tch]').forEach(initCompactTelepathyHero); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["telepathy-premium-ebook-product"] && !Shopify.designMode) return;
  try {
    
  function initPremiumEbookGallery(gallery) {
    if (gallery.dataset.ready === 'true') return;
    gallery.dataset.ready = 'true';
    var viewport = gallery.querySelector('[data-peb-viewport]');
    var slides = Array.from(gallery.querySelectorAll('[data-peb-slide]'));
    var dots = Array.from(gallery.querySelectorAll('[data-peb-dot]'));
    var currentLabel = gallery.querySelector('[data-peb-current]');
    var current = 0;
    var ticking = false;
    if (!viewport || slides.length < 2) return;

    function update(index) {
      current = Math.max(0, Math.min(slides.length - 1, index));
      if (currentLabel) currentLabel.textContent = String(current + 1);
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === current);
        dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
      });
    }

    viewport.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        update(Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1)));
        ticking = false;
      });
    }, { passive: true });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = Number(dot.dataset.index || 0);
        viewport.scrollTo({ left: index * viewport.clientWidth, behavior: 'smooth' });
        update(index);
      });
    });
    update(0);
  }

  function initPremiumEbookSticky(root) {
    var form = root.querySelector('.peb__form');
    var sticky = root.querySelector('[data-peb-sticky]');
    if (!form || !sticky || sticky.dataset.ready === 'true') return;
    sticky.dataset.ready = 'true';
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function(entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: .08 });
    observer.observe(form);
  }

  document.querySelectorAll('[data-peb-gallery]').forEach(initPremiumEbookGallery);
  document.querySelectorAll('.peb').forEach(initPremiumEbookSticky);
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-peb-gallery]').forEach(initPremiumEbookGallery);
    event.target.querySelectorAll('.peb').forEach(initPremiumEbookSticky);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["telepathy-premium-promo-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const parseDate = (value) => {
    if (!value) return null;
    const time = Date.parse(value);
    return Number.isNaN(time) ? null : time;
  };
  const storageBlocked = (element) => {
    const key = element.dataset.storageKey;
    try {
      const sessionValue = sessionStorage.getItem(key);
      if (sessionValue === 'dismissed') return true;
      const saved = Number(localStorage.getItem(key));
      return saved > Date.now();
    } catch (error) {
      return false;
    }
  };
  const rememberDismissal = (element) => {
    const key = element.dataset.storageKey;
    const days = Number(element.dataset.rememberDays || 0);
    try {
      if (days > 0) localStorage.setItem(key, String(Date.now() + days * 86400000));
      else sessionStorage.setItem(key, 'dismissed');
    } catch (error) {}
  };
  const scheduleAllows = (element) => {
    if (element.dataset.designMode === 'true') return true;
    if (element.dataset.active !== 'true') return false;
    const now = Date.now();
    const start = parseDate(element.dataset.start);
    const end = parseDate(element.dataset.end);
    if (start && now < start) return false;
    if (end && now >= end) return false;
    return true;
  };
  const updateCountdown = (element) => {
    const output = element.querySelector('[data-tp-banner-countdown]');
    const end = parseDate(element.dataset.end);
    if (!output || !end) return;
    const remaining = end - Date.now();
    if (remaining <= 0) {
      element.hidden = true;
      return;
    }
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    output.textContent = `${output.dataset.label} ${days}d ${hours}h`;
  };
  const init = (element) => {
    if (element.dataset.ready === 'true') return;
    element.dataset.ready = 'true';
    if (!scheduleAllows(element) || (element.dataset.designMode !== 'true' && storageBlocked(element))) return;
    element.hidden = false;
    updateCountdown(element);
    const timer = setInterval(() => updateCountdown(element), 60000);
    element.querySelector('[data-tp-banner-close]')?.addEventListener('click', () => {
      rememberDismissal(element);
      element.hidden = true;
      clearInterval(timer);
    });
    element.querySelectorAll('[data-tp-copy-code]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.code || '');
          const label = button.querySelector('span');
          if (label) label.textContent = button.dataset.copied;
        } catch (error) {}
      });
    });
  };
  const initAll = (root = document) => root.querySelectorAll('[data-tp-promo-banner]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["telepathy-premium-promo-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const parseDate = (value) => {
    if (!value) return null;
    const time = Date.parse(value);
    return Number.isNaN(time) ? null : time;
  };
  const scheduleAllows = (popup) => {
    if (popup.dataset.active !== 'true') return false;
    const now = Date.now();
    const start = parseDate(popup.dataset.start);
    const end = parseDate(popup.dataset.end);
    if (start && now < start) return false;
    if (end && now >= end) return false;
    return true;
  };
  const frequencyBlocked = (popup) => {
    const mode = popup.dataset.frequency;
    const key = popup.dataset.storageKey;
    if (mode === 'every') return false;
    try {
      if (mode === 'session') return sessionStorage.getItem(key) === 'shown';
      return Number(localStorage.getItem(key)) > Date.now();
    } catch (error) {
      return false;
    }
  };
  const remember = (popup) => {
    const mode = popup.dataset.frequency;
    const key = popup.dataset.storageKey;
    try {
      if (mode === 'session') sessionStorage.setItem(key, 'shown');
      if (mode === 'days') {
        const days = Number(popup.dataset.rememberDays || 7);
        localStorage.setItem(key, String(Date.now() + days * 86400000));
      }
    } catch (error) {}
  };
  const close = (popup) => {
    remember(popup);
    if (popup.open && typeof popup.close === 'function') popup.close();
    else popup.removeAttribute('open');
  };
  const updateCountdown = (popup) => {
    const output = popup.querySelector('[data-tp-popup-countdown]');
    const end = parseDate(popup.dataset.end);
    if (!output || !end) return true;
    const remaining = end - Date.now();
    if (remaining <= 0) {
      close(popup);
      return false;
    }
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    output.textContent = `${output.dataset.label} ${days}d ${hours}h`;
    return true;
  };
  const open = (popup) => {
    if (popup.open || !scheduleAllows(popup) || frequencyBlocked(popup)) return;
    try {
      if (typeof popup.showModal === 'function') popup.showModal();
      else popup.setAttribute('open', '');
    } catch (error) {
      popup.setAttribute('open', '');
    }
    updateCountdown(popup);
    remember(popup);
  };
  const setupTrigger = (popup) => {
    const trigger = popup.dataset.trigger;
    if (trigger === 'scroll') {
      const onScroll = () => {
        const height = document.documentElement.scrollHeight - window.innerHeight;
        const progress = height > 0 ? (window.scrollY / height) * 100 : 100;
        if (progress >= Number(popup.dataset.scroll || 35)) {
          window.removeEventListener('scroll', onScroll);
          open(popup);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }
    if (trigger === 'exit') {
      const onExit = (event) => {
        if (event.clientY <= 0) {
          document.removeEventListener('mouseout', onExit);
          open(popup);
        }
      };
      document.addEventListener('mouseout', onExit);
      return;
    }
    window.setTimeout(() => open(popup), Number(popup.dataset.delay || 3) * 1000);
  };
  const init = (popup) => {
    if (popup.dataset.ready === 'true') return;
    popup.dataset.ready = 'true';
    popup.querySelector('[data-tp-popup-close]')?.addEventListener('click', () => close(popup));
    popup.addEventListener('cancel', () => remember(popup));
    popup.querySelectorAll('[data-tp-popup-action]').forEach((link) => link.addEventListener('click', () => remember(popup)));
    popup.querySelector('[data-tp-popup-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      try {
        await navigator.clipboard.writeText(button.dataset.code || '');
        const label = button.querySelector('em');
        if (label) label.textContent = button.dataset.copied;
      } catch (error) {}
    });
    if (!scheduleAllows(popup) || frequencyBlocked(popup)) return;
    setupTrigger(popup);
    window.setInterval(() => updateCountdown(popup), 60000);
  };
  const initAll = (root = document) => root.querySelectorAll('[data-tp-promo-popup]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["telepathy-sticky-category-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-tp-category-nav]';
    const normalizePath = value => {
      const path = value || '/';
      return path.length > 1 ? path.replace(/\/$/, '') : path;
    };
    const setActive = root => {
      if (root.dataset.activeMode !== 'automatic') return;
      const current = normalizePath(window.location.pathname);
      const links = [...root.querySelectorAll('[data-tp-category-link]')];
      let selected = null;
      links.forEach(link => {
        link.classList.remove('is-active');
        link.removeAttribute('aria-current');
        const target = normalizePath(new URL(link.href, window.location.origin).pathname);
        const prefixMatch = link.dataset.matchPrefix === 'true' && target !== '/' && (current === target || current.startsWith(`${target}/`));
        if (!selected && (current === target || prefixMatch)) selected = link;
      });
      if (!selected && current === '/') selected = links.find(link => normalizePath(new URL(link.href, window.location.origin).pathname) === '/');
      if (!selected) return;
      selected.classList.add('is-active');
      selected.setAttribute('aria-current', 'page');
      requestAnimationFrame(() => selected.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'}));
    };
    const setStickyOffset = root => {
      if (root.dataset.sticky !== 'true') return;
      let scheduled = false;
      const update = () => {
        scheduled = false;
        let top = Number.parseFloat(getComputedStyle(root).getPropertyValue('--tp-cat-manual-top')) || 0;
        const candidates = document.querySelectorAll('sticky-header,.shopify-section-header-sticky,[data-sticky-header]');
        candidates.forEach(header => {
          if (header.contains(root)) return;
          const style = getComputedStyle(header);
          const rect = header.getBoundingClientRect();
          if ((style.position === 'sticky' || style.position === 'fixed') && rect.bottom > 0 && rect.top <= top + 2) top = Math.max(top, Math.round(rect.bottom));
        });
        root.style.setProperty('--tp-category-top', `${top}px`);
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      };
      update();
      window.addEventListener('resize', schedule, {passive:true});
      window.addEventListener('scroll', schedule, {passive:true});
    };
    const init = scope => {
      const roots = scope.matches?.(selector) ? [scope] : scope.querySelectorAll?.(selector) || [];
      roots.forEach(root => {
        if (root.dataset.ready === 'true') return;
        root.dataset.ready = 'true';
        setActive(root);
        setStickyOffset(root);
      });
    };
    init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:block:select', event => {
      const item = event.target.closest?.('.tp-category-nav__item');
      item?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["telepathy-sticky-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.telepathyStickyFooterScroll) {
      window.telepathyStickyFooterScroll.refresh();
      return;
    }

    var lastY = window.scrollY;
    var ticking = false;

    function refresh() {
      var currentY = window.scrollY;
      var movingDown = currentY > lastY + 2;
      var movingUp = currentY < lastY - 2;

      document.querySelectorAll('[data-telepathy-sticky-footer]').forEach(function (footer) {
        if (footer.dataset.shrinkOnScroll !== 'true') {
          footer.classList.remove('is-compact');
          return;
        }

        var threshold = Number(footer.dataset.compactAfter) || 120;
        if (currentY <= threshold || movingUp) {
          footer.classList.remove('is-compact');
        } else if (movingDown) {
          footer.classList.add('is-compact');
        }
      });

      lastY = currentY;
      ticking = false;
    }

    function requestRefresh() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(refresh);
    }

    window.addEventListener('scroll', requestRefresh, { passive: true });
    window.addEventListener('pageshow', requestRefresh);
    document.addEventListener('shopify:section:load', requestRefresh);
    window.telepathyStickyFooterScroll = { refresh: requestRefresh };
    requestRefresh();
  })();

  } catch(e) { console.error(e); }
})();
})();
